// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"cc5bb075","787":"69ecd6a6"}[chunkId] + ".chunk.js";
};